/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useState } from "react";

export const useUserPreference = () => {
  const [userPreference, setUserPreference] = useState<{
    showAnimation?: boolean;
  }>({
    showAnimation: !window.matchMedia("(prefers-reduced-motion: reduce)").matches,
  });

  return userPreference;
};
